import { CSSProperties } from "react";
import { ResponsivePicture } from "src/atoms/ResponsivePicture";
import type { BannerImageSet } from "./PromotionBannerTypes";

type PromotionBannerImageProps = {
  images: BannerImageSet;
  alt?: string;
  sizes: string;
  className?: string;
  style?: CSSProperties;
  fallbackAspectRatio?: string | number;
  priority?: boolean;
};

function PromotionBannerImage({
  images,
  alt = "",
  sizes,
  className,
  style,
  fallbackAspectRatio = "3 / 1",
  priority = false,
}: PromotionBannerImageProps) {
  return (
    <ResponsivePicture
      mobile={{
        src: images.mobile,
        width: images.mobileWidth,
        height: images.mobileHeight,
      }}
      tablet={{
        src: images.tablet,
        width: images.tabletWidth,
        height: images.tabletHeight,
      }}
      desktop={{ src: images.desktop }}
      alt={alt}
      sizes={sizes}
      priority={priority}
      fallbackAspectRatio={fallbackAspectRatio}
      className={className}
      style={style}
    />
  );
}

export { PromotionBannerImage };
